import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  apiUrl = null;
  apiUrlSoc = null;
  appProfile = null;
  private _hubConnection: HubConnection;
  private Token: string;
  constructor(private http: HttpClient) { }
  getAccessToken(){
    return localStorage.getItem('access_token');
  }
  private getHeaders(file = false) {
    let headers = new HttpHeaders();
    if(!file){
      headers = headers.set('Content-Type', 'application/json');
    }
    
    headers = headers.set('Authorization', `Bearer ${this.getAccessToken()}`);
    return headers;
  }
  getApi(url: string):Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  postApi(url: string, postValue: any):Observable<any> {
    return this.http.post(url, postValue, { headers: this.getHeaders() }).pipe(
      map(res => {      
        return res = res;
      }),
      catchError(err => {         
        this.catchError(err); 
        return of(err.message) })
    );
  }
  catchError(err) {    
    throw err;
  }
  private defaultNotifications = new BehaviorSubject([]);
  currentNotifications  = this.defaultNotifications.asObservable();

  changeNotifications (data){
    this.defaultNotifications.next(data);
  }
  notificationCount = new BehaviorSubject(0);
  notificationCount$ = this.notificationCount.asObservable();
  getNewAlert = new BehaviorSubject<any>({});
  getStarted = new Subject<any>();
  getNewAlert$ = this.getNewAlert.asObservable();
  getStarted$ = this.getNewAlert.asObservable();
  getNotification(principleName,appId) {
    var countryCode = localStorage.getItem('countryVal');
    return this.getApi(this.apiUrl+`Notification/GetMessages/${principleName}/${appId}/${countryCode}`);
  }
  getAllNotification(principleName,appId) {
    var countryCode = localStorage.getItem('countryVal');
    return this.getApi(this.apiUrl+`Notification/GetAllMessagesByUser/${principleName}/${appId}/${countryCode}`);
  }
  updateNotifyData(postData) {
    postData.userId = this.appProfile;
    return this.postApi(this.apiUrl + "Notification/UpdateMessagesReadStatus", postData);
  }
  updateSendNotifyData(postData) {
    postData.userId = this.appProfile;
    return this.postApi(this.apiUrl + "Notification/UpdateMessagesSentStatus", postData);
  }
  getMessageById(msgId){
    return this.getApi(this.apiUrl+`Notification/GetMessagebyId/`+msgId);
  }
  signInHandshake(){
    return this.getApi(this.apiUrl+`Notification/HandshakeonSignIn`);
  }
  timeCon24To12(input):string // 24 hrs to 12 hrs format
    {
      if(input)
      {
        let time = input.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [input];
        if (time.length > 1) { // If time format correct
          time = time.slice (1);  // Remove full string match value
          time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        let fTime = time.join ('');
        return fTime;
      }
    }
  InitiateHubConnection(strtoken:any)
  {
    //console.log("notify");
    this._hubConnection = new HubConnectionBuilder().withUrl(this.apiUrlSoc+`notify`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => strtoken
    }
    ).build();
    this.StartHubConnection();
  }
  InitiateHubEvents(): void {
    this._hubConnection.on('BroadcastMessage', (payload: string) => {
      console.log("BroadcastMessage   =====",payload)
      this.getNewAlert.next(payload);
      // if (confirm(payload)) {
      //   this._hubConnection.invoke('updatemessages', payload).catch(error => {
      //     console.log(error)
      //   });
      // }

    });
  }

  StartHubConnection(): void {
    //console.log(this._hubConnection.state); 
    this._hubConnection.stop().then(() => {
      //console.log("stopped");
      this._hubConnection
      .start()
      .then(() => {
        //console.log('Connection started!');
        this.getStarted.next(true);
      })
      .catch(err => {
        //console.log('Error while establishing connection',err);
        setTimeout(() => this.StartHubConnection(), 3000)
      });
    }).catch(err => console.log(err));
    this.InitiateHubEvents();
  }
}
